import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ShoppingCart } from 'lucide-react'
import { useForbiddenWords } from '@/hooks/useForbiddenWords'
import { useAmazonTitleValidator } from '@/hooks/useAmazonTitleValidator'
import { TitleInput } from './TitleInput'
import { TitleResultsTable } from './TitleResultsTable'
import { ForbiddenWordsEditor } from './ForbiddenWordsEditor'

export function AmazonTitleChecker() {
  const { t } = useTranslation()
  const [rawInput, setRawInput] = useState('')
  const { words, addWord, removeWord, resetToDefault } = useForbiddenWords()
  const { results, titleCount } = useAmazonTitleValidator(rawInput, words)

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 shadow-lg shadow-orange-500/30">
          <ShoppingCart className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-neutral-900 dark:text-white tracking-tight">
            {t('amazonTitleTool.title')}
          </h1>
          <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1">
            {t('amazonTitleTool.subtitle')}
          </p>
        </div>
      </div>
      <TitleInput value={rawInput} onChange={setRawInput} titleCount={titleCount} />
      <ForbiddenWordsEditor words={words} onAdd={addWord} onRemove={removeWord} onReset={resetToDefault} />
      <TitleResultsTable results={results} />
    </div>
  )
}
